import { Plus } from 'lucide-react';

import { Button } from 'components/Button';
import { Flex } from 'components/layout';
import { Typography } from 'components/typography';
import { ButtonNamePosthog } from 'types/enums/CustomPosthogEvents';

interface CreateLocationButtonProps {
  onClick: () => void;
  disabled?: boolean;
}

export function CreateLocationButton({
  onClick,
  disabled = false,
}: CreateLocationButtonProps) {
  return (
    <Button
      buttonNamePosthog={ButtonNamePosthog.CreateNewLocation}
      type='button'
      variant='unstyled'
      onClick={onClick}
      disabled={disabled}
      className='w-full justify-start h-auto py-1.5 px-0 hover:opacity-80 transition-opacity'
      title='Create new location'
    >
      <Flex align='center' gap='xs'>
        <Plus className='h-3.5 w-3.5 stroke-accent-600!' strokeWidth={2.5} />
        <Typography variant='body-sm' className='text-accent-600'>
          Create new location
        </Typography>
      </Flex>
    </Button>
  );
}
